import React from 'react'
import { AnnouncementContainer } from '../styled_components/styles'

const Announcement = () => {
  return (
    <AnnouncementContainer>
        DEAL OF THE MONTH!: FREE SHIPPING ON ORDERS OVER $99.99
    </AnnouncementContainer>
  )
}

export default Announcement